export default "__VITE_ASSET__752b8f89__"